/**
 * @file コンポーネント：検索絞り込みセクション スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledSection = styled.section`
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledSectionHeadline = styled.h3`
    margin-bottom: 8px;
    color: #ffffff;
    font-weight: normal;
    font-size: 20px;
    line-height: 48px;
`;
